import React, { useState, useEffect } from "react";
import axios from "axios";

import UserCard from "./UserCard";

import "./index.scss";

export default function DealerRepInfo({ fetchUrl }) {
  const [name, setName] = useState("");
  const [filename, setFilename] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);

  if (!fetchUrl) return null;

  useEffect(() => {
    fetchDealer();
  }, []);

  function fetchDealer() {
    axios
      .get(fetchUrl)
      .then(({ data }) => {
        if (!data.territory_manager) return;

        setName(
          `${data.territory_manager.first_name} ${data.territory_manager.last_name}`
        );
        setEmail(data.territory_manager.email);
        setPhone(data.territory_manager.phone);
        setFilename(data.territory_manager.avatar_filename);
        setLoading(false);
      })
      .catch((err) => {});
  }

  if (loading) return null;

  return (
    <UserCard
      name={name}
      subtitle="My Dealer Rep"
      phone={phone}
      filename={filename}
      email={email}
      pathPrefix="/dealer"
    />
  );
}

DealerRepInfo.defaultProps = {
  fetchUrl: "",
};
